import {useState} from "react"

const SIDEBAR_COLLAPSED_KEY = "sidebarCollapsed"
const SIDEBAR_COLLAPSED_DEFAULT = true


export function useSidebarState() {
    const [collapsed, setCollapsed] = useState(
        () => (
            localStorage.getItem(SIDEBAR_COLLAPSED_KEY) !== undefined
                ? localStorage.getItem(SIDEBAR_COLLAPSED_KEY) === "1"
                : SIDEBAR_COLLAPSED_DEFAULT
        )
    )

    const toggle = () => {
        setCollapsed(prev => {
            const next = !prev
            localStorage.setItem(SIDEBAR_COLLAPSED_KEY, next ? "1" : "0")
            return next
        })
    }

    return {collapsed, toggle}
}